<template>
  <div id="leaseTransact">
    <Modal v-model="showModel" title="编辑" width="45" :styles="{ 'z-index': '20' }">
      <div slot="title">起租办理基本信息</div>
      <div class="content-form">
        <Form class="from" ref="formValidates" :model="formValidate" :label-width="125" inline :rules="ruleValidate">
          <FormItem label="租借人" prop="leaseeId">
            <leasee-select roleType="LEASEE" @onChange="onChangeLeasee" v-model="formValidate.leaseeId" :disabled="true" />
          </FormItem>
          <FormItem label="标的物小类" prop="targetType" key="targetType" v-if="agreementNoStatus">
            <Select v-model="formValidate.targetType" style="width: 200px" filterable clearable label-in-value @on-change="onTargetType">
              <Option v-for="item in targetList" :value="item.code" :key="item.id">{{ item.text }}</Option>
            </Select>
          </FormItem>
          <br />
          <FormItem label="框架协议号" prop="agreementNo" v-if="agreementNoStatus" key="agreementNo">
            <Select v-model="formValidate.agreementNo" style="width: 200px" filterable clearable label-in-value @on-change="handleAgreementNO">
              <Option v-for="item in cityList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <Button style="margin-top: 5px" type="success" @click="goDetail" :disabled="formValidate.agreementNo ? false : true" size="small">查看协议详情</Button>
          <br />
          <FormItem v-if="rentTermShow" label="约定期限">
            <Input type="number" empty :min="1" style="width: 200px" :disabled="rentDisable" v-model="formValidate.rentTerm" />
          </FormItem>
          <FormItem label="订单数量" prop="orderAmount">
            <InputNumber :min="1" v-model="formValidate.orderAmount" style="width: 200px" />
          </FormItem>
          <br />
          <FormItem label="预期交付时间" prop="expectedDeliveryDate">
            <DatePicker type="date" placeholder="请选择预期交付时间" :editable="false" @on-change="expectDate" v-model="formValidate.expectedDeliveryDate" style="width: 200px" format="yyyy-MM-dd"></DatePicker>
          </FormItem>
          <FormItem label="是否清洗" prop="cleaningRequired">
            <dict-select key="1" id="bitYesNo" @on-change="onChangeCode" :exclusion="[]" v-model="formValidate.cleaningRequired" />
          </FormItem>
          <br />
          <FormItem label="交付方式" prop="deliveryMethod">
            <dict-select namespace="ENUM_MID-OPERATE-LEASE" id="order.DeliveryMethod" :exclusion="[]" @on-change="onOrderMethod" v-model="formValidate.deliveryMethod" />
          </FormItem>
          <FormItem label="最大租赁额度">
            <InputNumber style="width: 200px" disabled v-model="maxAmount" />
          </FormItem>
          <br />
          <FormItem label="责任分区" v-show="formValidate.leaseeId">
            <bizSelect v-if="formValidate.leaseeId" v-model="formValidate.groupFlag" url="http://CORE-MEMBER/messageService/respZoneService/queryRespZoneByMemberId" :params="{ memberId: formValidate.leaseeId }" codeField="respZoneId" style="width: 200px" />
          </FormItem>
          <br />
          <FormItem label="备注" key="2">
            <Input v-model="formValidate.leaseOrderComment" type="textarea" style="width: 540px" />
          </FormItem><br />
          <FormItem label="上传附件" key="3">
            <upload ref="upFile" :height="70" :width="540" :uploadList="uploadList" @success="uploadSuccess" @delete="onDelete"></upload>
          </FormItem>
          <template v-if="formValidate.deliveryMethod === 'DOORSTEP'">
            <Divider orientation="left">收货地址</Divider>
            <FormItem label="所在区域" prop="receiveArea">
              <addr-cascader @on-select-change="onSelect" v-model="formValidate.receiveArea" />
            </FormItem>
            <Button style="margin-top: 5px" type="success" @click="queryArea" :disabled="formValidate.leaseeId ? false : true" size="small">选择地址</Button>
            <br />
            <FormItem label="详细地址" prop="receiveAddress">
              <Input v-model="formValidate.receiveAddress" maxlength="100" show-word-limit type="textarea" style="width: 200px" />
            </FormItem>
            <Button style="margin-top: 5px" type="success" @click="onRecognition" :disabled="
                formValidate.receiveAddress && formValidate.leaseeId
                  ? false
                  : true
              " size="small">识别</Button>
            <br />
          </template>
          <template v-if="formValidate.leaseeId">
            <Divider orientation="left">联系人信息</Divider>
            <Button type="success" style="margin: 0 0 10px 39px" @click="addLinkMan">选择联系人</Button>
            <br />
            <FormItem label="联系人姓名">
              <Input v-model="linkVal.name" disabled style="width: 200px" />
            </FormItem>
            <FormItem label="手机号">
              <Input v-model="linkVal.mobile" disabled style="width: 200px" />
            </FormItem>
            <br />
            <FormItem label="邮箱">
              <Input v-model="linkVal.email" disabled style="width: 200px" />
            </FormItem>
            <FormItem label="证件号">
              <Input v-model="linkVal.identityNo" disabled style="width: 200px" />
            </FormItem>
            <br />
          </template>
        </Form>
        <contact-select ref="contactSelect" @on-select-contact="onSelectContact"></contact-select>
        <query-area ref="queryAreaRef" @onRow="onRow"></query-area>
      </div>
      <div slot="footer">
        <!-- <Button type="primary" @click="modalShow = false">取消</Button> -->
        <Button type="primary" @click="submit">确认</Button>
      </div>
    </Modal>
    <frameworkAgreeModel v-if="showFrameworkAgree" ref="frameworkAgree" :paramsData="currentParams"></frameworkAgreeModel>
  </div>
</template>

<script>
import addrCascader from "@/components/select/addr-cascader.vue";
import leaseeSelect from "@/components/select/payee-select.vue";
import dictSelect from "@/components/select/dict-select.vue";
import targetTypeCascader from "@/components/select/targetType-cascader";
import contactSelect from "@/components/select/contact-select.vue";
import queryArea from "./compoent/queryArea.vue";
import upload from "_c/upload/upload.vue";
import bizSelect from "_c/select/biz-select";

import frameworkAgreeModel from "../leaseList/frameworkAgreeModel";

export default {
  name: "leaseTransact",
  components: {
    addrCascader,
    leaseeSelect,
    dictSelect,
    targetTypeCascader,
    contactSelect,
    frameworkAgreeModel,
    queryArea,
    upload,
    bizSelect,
  },
  data() {
    return {
      oldRentTerm: "",
      agreementNoStatus: true,
      uploadList: [], // 文件列表
      showFrameworkAgree: false, // 协议弹窗
      showModel: false,
      currentChild: undefined,
      currentParams: undefined,
      rentDisable: false,
      cityList: [],
      targetList: [], //标的物小类
      rentTermShow: true,
      attachmentFileIds: [], //附件
      formValidate: {
        orderNo: undefined,
        leaseeId: undefined, //租借人ID
        targetType: undefined, //标的小类
        cleaningRequired: undefined, //是否清洗
        receiveAddress: undefined,
        receiveArea: undefined, //所在区域
        receiveContactId: undefined, //联系人id,
        agreementNo: 0, //框架协议号
        orderAmount: undefined, //订单数量
        expectedDeliveryDate: undefined, //预期交付时间
        deliveryMethod: undefined, //交付方式
        rentTerm: null, //约定租期
        leaseOrderComment: undefined,
        groupFlag: undefined, //责任分区
      },
      maxAmount: undefined, //最大租赁额度
      linkVal: {
        name: undefined,
        mobile: undefined,
        email: undefined,
        identityNo: undefined,
      },
      ruleValidate: {
        leaseeId: [{ required: true, message: "租借人不能为空！" }],
        targetType: [
          { required: true, message: "请选择标的物小类", trigger: "change" },
        ],
        cleaningRequired: [
          { required: true, message: "请选择是否清洗！", trigger: "change" },
        ],
        agreementNo: [
          { required: true, message: "请选择框架协议号！", trigger: "change" },
        ],
        expectedDeliveryDate: [
          {
            required: true,
            message: "请选择预期交付时间",
            trigger: "blur",
            pattern: /.+/,
          },
        ],
        orderAmount: [{ required: true, message: "订单数量不能为空！" }],
        deliveryMethod: [
          { required: true, message: "请选择交付方式", trigger: "change" },
        ],
        cleaningRequired: [
          { required: true, message: "请选择是否清洗", trigger: "change" },
        ],
        rentTerm: [{ required: true, message: "约定租期不能为空" }],
        receiveAddress: [{ required: true, message: "详细地址不能为空" }],
        receiveArea: [{ required: true, message: "请选择所在区域" }],
      },
    };
  },
  mounted() { },
  methods: {
    async init(id) {
      // this.$nextTick(() => {
      this.agreementNoStatus = false;
      this.showModel = true;
      let data = {
        url: "MID-OPERATE-LEASE/messageService/orderService/queryOrderDetail",
        body: { orderNo: id },
      };
      let res = await this.invoke(data);
      if (res) {
        this.formValidate = res;
        this.oldRentTerm = res.rentTerm;
        this.agreementNoStatus = true;
        this.formValidate.expectedDeliveryDate = new Date(
          this.formValidate.expectedDeliveryDate
        );
        await this.agreementList();

        // 文件回显
        this.getUploadList();
        // 联系人
        this.getReceiveContactInfo();
        this.getTargetList();
        this.handleAgreementNO(this.formValidate.agreementNo);
      } else {
        this.$Message.error("请求订单数据失败");
      }

      // });
    },
    getUploadList() {
      this.uploadList = [];
      this.attachmentFileIds = [];
      if (this.formValidate.attachmentFiles) {
        this.formValidate.attachmentFiles.forEach((item) => {
          this.uploadList.push({
            name: item.name,
            url: item.fileId,
          });
          this.attachmentFileIds.push(item.fileId);
        });
      }
    },
    // 编辑回显找到联系人
    getReceiveContactInfo() {
      let param = {
        url: "http://CORE-MEMBER/messageService/contactService/queryContactListByMemberId",
        body: { memberId: this.formValidate.leaseeId, excludeDisabled: true },
      };
      this.invoke(param).then((res) => {
        var receiveContactList = res;
        for (var i = 0; i < receiveContactList.length; i++) {
          if (receiveContactList[i].id == this.formValidate.receiveContactId) {
            this.linkVal.name = receiveContactList[i].name;
            this.linkVal.mobile = receiveContactList[i].mobile;
            this.linkVal.email = receiveContactList[i].email;
            this.linkVal.identityNo = receiveContactList[i].identityNo;
            break;
          }
        }
      });
    },
    // 上传成功
    uploadSuccess(params) {
      this.attachmentFileIds.push(params.body);
    },
    // 附件删除
    onDelete(params) {
      var key = this.attachmentFileIds.indexOf(params.id);
      this.attachmentFileIds.splice(key, 1);
    },
    // 识别省市区
    onRecognition() {
      let data = {
        url: "CORE-COMMON/messageService/regionService/autoRecognizeRegion",
        body: { address: this.formValidate.receiveAddress },
      };
      this.invoke(data).then((res) => {
        if (res) {
          this.$Message.success("识别成功");
          this.formValidate.receiveArea = res.regionCode;
          this.formValidate.receiveAddress = res.address;
        } else {
          this.$Message.error("请输入符合规范详细地址");
        }
      });
    },

    // 选择地址
    queryArea() {
      if (this.formValidate.leaseeId) {
        this.$refs["queryAreaRef"].openModal(this.formValidate.leaseeId);
      }
    },
    onRow(params) {
      this.formValidate.receiveArea = params.areaId;
      this.formValidate.receiveAddress = params.address;
      this.linkVal.name = params.contactName;
      this.linkVal.mobile = params.contactMobile;
      this.linkVal.email = params.contactEmail;
      this.linkVal.identityNo = params.contactIdentityNo;
      this.formValidate.receiveContactId = params.defaultContactId;
    },
    // 查看框架协议详情
    goDetail() {
      this.showFrameworkAgree = true;
      this.currentParams = this.formValidate.agreementNo;
      this.$nextTick(() => {
        this.$refs.frameworkAgree.init();
      });
    },
    // 租借人
    onChangeLeasee(val) {
      if (val) {
        this.formValidate.leaseeId = val;
        this.formValidate.targetType = "";
        this.getTargetList();
      }
      if (this.formValidate.leaseeId && this.formValidate.targetType) {
        this.agreementList();
        this.formValidate.agreementNo = "";
      }
    },
    // 框架协议号
    handleAgreementNO(vals) {
      let val = vals.value || vals;
      if (val) {
        this.formValidate.agreementNo = val;
      }
      let modelId = "";
      if (val) {
        this.cityList.forEach((item) => {
          if (item.id === val) {
            console.log(item);
            modelId = item.modelId;
            if (item.maxAmount) this.maxAmount = item.maxAmount;
          }
        });
      }
      if (modelId == "06") {
        this.rentTermShow = false;
        this.maxAmount = "";
        this.formValidate.rentTerm = "";
      } else {
        this.rentTermShow = true;
        this.cityList.forEach((item) => {
          if (val === item.id) {
            if (item.rentTerm) {
              this.formValidate.rentTerm = item.rentTerm;
              this.rentDisable = true;
            } else {
              this.rentDisable = false;
              this.formValidate.rentTerm = this.oldRentTerm;
            }
          }
        });
      }
    },
    // 所在区域
    onSelect(params) {
      this.formValidate.receiveArea = params;
    },
    // 交付方式
    onOrderMethod(val) {
      this.formValidate.deliveryMethod = val;

      if (val === "SELF_PICK") {
        this.formValidate.receiveArea = "";
        this.formValidate.receiveAddress = "";
      }
    },
    //标的物小类
    onTargetType(params) {
      this.formValidate.targetType = params.value;
      if (this.formValidate.leaseeId && this.formValidate.targetType) {
        this.agreementList();
        this.formValidate.agreementNo = "";
      }
    },
    addLinkMan() {
      this.$refs["contactSelect"].openModal(this.formValidate.leaseeId);
    },
    // 选择联系人
    onSelectContact(params) {
      this.formValidate.receiveContactId = params.id;
      this.linkVal = params;
    },
    // 是否清洗
    onChangeCode(val) {
      this.formValidate.cleaningRequired = val;
    },
    // 预期交付时间
    expectDate(val) {
      this.formValidate.expectedDeliveryDate = val;
    },
    // 标的物小类数据
    getTargetList() {
      //   this.targetList = [];
      let data = {
        url: "CORE-CONTRACT/messageService/billingModelService/queryTargetTypesByLeaseeId",
        body: {
          leaseeId: this.formValidate.leaseeId,
        },
      };
      this.invoke(data).then((res) => {
        if (res) {
          this.targetList = res;
        }
      });
    },
    // 框架协议号
    async agreementList() {
      let data = {
        url: "CORE-CONTRACT/messageService/queryService/queryFrameRentListByCondition4Order",
        body: {
          memberId: this.formValidate.leaseeId,
          targetType: this.formValidate.targetType,
        },
      };
      this.cityList = await this.invoke(data);
    },

    async submit() {
      let valid = await this.$refs["formValidates"].validate();
      if (!valid) return;

      let checkData = {
        url: "MID-OPERATE-LEASE/messageService/orderService/checkFrameMaxAmoutLimit",
        body: {
          agreementNo: this.formValidate.agreementNo,
          orderAmount: this.formValidate.orderAmount,
        },
      };
      let rentInfo = await this.invoke(checkData);

      let urls = "http://MID-DATA-REPORT/messageService/reportService/queryDepositDiffs";
      let queryDepositDiffs = await this.invoke(urls, { frameRent: this.formValidate.agreementNo,applyAmount: this.formValidate.orderAmount });
      queryDepositDiffs = queryDepositDiffs || false;

      let modalTitle = "确认";
      let modalContent = "确定要编辑租赁吗?";
      if (!rentInfo.valid) {
        modalTitle = "提示";
        modalContent = `框架最大数量限制为${rentInfo.maxAmount},已在租数为:${rentInfo.rentingAmount},\n是否继续提交修改?`;
      }
      if (queryDepositDiffs && queryDepositDiffs?.depositDiff > 0) {
        modalTitle = "提示";
        modalContent = `此客户押金缴纳不足，应缴 ${queryDepositDiffs.leaseeDepositAmount} 元，实缴 ${queryDepositDiffs.accountAmount} 元,\n是否继续提交修改?`;
      }

      if (!rentInfo.valid && queryDepositDiffs && queryDepositDiffs?.depositDiff > 0) {
        modalTitle = "提示";
        modalContent = `框架最大数量限制为${rentInfo.maxAmount},已在租数为:${rentInfo.rentingAmount},\n
          此客户押金缴纳不足，应缴 ${queryDepositDiffs.leaseeDepositAmount} 元，实缴 ${queryDepositDiffs.accountAmount} 元,\n是否继续提交修改?`;
      }

      let data = {
        url: "MID-OPERATE-LEASE/messageService/orderService/updateOrder",
        body: {
          order: this.formValidate,
          attachmentFileIds: this.attachmentFileIds,
        },
      };
      this.$Modal.confirm({
        title: modalTitle,
        content: modalContent,
        onOk: () => {
          this.invoke(data).then(() => {
            this.$Message.success("编辑租赁成功！");
            this.showModel = false;
            this.$emit("onFinish");
            //   this.reset();
          });
        },
      });
    },
    reset() {
      this.formValidate.targetType = null;
      this.$refs["formValidates"].resetFields();
      this.$refs.upFile.$refs.uploadFile.clearFiles();

      this.attachmentFileIds = [];
      this.formValidate.leaseOrderComment = "";
      this.formValidate.rentTerm = "";
      this.formValidate.maxAmount = "";
      this.linkVal = {
        name: "",
        mobile: "",
        email: "",
        identityNo: "",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.content-form {
  display: flex;
  justify-content: center;
}
::v-deep .ivu-modal {
  width: 45%;
  min-width: 900px;
}
</style>